<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input class="filter-item" v-model="search.name" clearable placeholder="序列号" style="width: 300px;" @keyup.enter.native="handleFilter"/>
      <el-select class="filter-item" v-model="search.status" clearable placeholder="状态">
        <el-option v-for="kv in option.status" :key="kv.k" :label="kv.v" :value="kv.k"></el-option>
      </el-select>
      <el-select class="filter-item" v-model="search.dash" clearable placeholder="快速筛选" :disabled="search.status != '' ">
        <el-option v-for="kv in option.dash" :key="kv.k" :label="kv.v" :value="kv.k"></el-option>
      </el-select>
      <el-button v-waves type="primary" class="filter-item" icon="el-icon-search" @click="handleFilter">查询</el-button>
    </div>

    <el-table class="tbl" v-loading="loading" :key="tableKey" :data="list" border fit highlight-current-row style="width: 100%;">
      <el-table-column label="条码号" prop="sn" fixed align="center" width="120px"></el-table-column>
      <el-table-column label="当前状态" align="center" width="80px">
        <template slot-scope="props">
          <span :class="'w' + props.row.status">{{ props.row.status | statusFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="规格" prop="spec" align="center" width="120px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="内部编号" prop="inno" align="center" width="120px"></el-table-column>
      <el-table-column label="检定时间" prop="day" align="center" width="100px"></el-table-column>
      <el-table-column label="年限" align="center" width="100px">
        <template slot-scope="props">
          {{ props.row.life | lifeFilter }}
        </template>
      </el-table-column>
      <el-table-column label="检定人" prop="user" align="center" width="100px"></el-table-column>
      <el-table-column label="级别" prop="level" align="center" width="100px"></el-table-column>
      <el-table-column label="分配组" prop="team" align="center" width="120px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="报废原因" prop="scrap_why" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="报废人" prop="scrap_who"></el-table-column>

      <el-table-column label="操作" align="center" width="100" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-tooltip content="编辑" class="item" effect="dark" placement="bottom">
            <el-button type="text" class="btn-text" @click="handleEdit(scope.row)">
              <svg-icon icon-class="edit"/>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container right">
      <el-pagination v-show="total > search.size" :current-page="search.page" :page-size="search.size" :total="total" layout="total, prev, pager, next" @current-change="handleCurrentChange"/>
    </div>

    <el-dialog class="dia" :title="!temp.id? '添加': '编辑'" :visible.sync="dia.edit" top="1vh">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="120px" style="max-width: 400px; margin-left:50px;">
        <el-form-item label="序列号" prop="sn">
          <el-input v-model="temp.sn" placeholder="请填写序列号，添加后不可修改" v-if="!temp.id" />
          <span v-else>{{ temp.sn }}</span>
        </el-form-item>
        <el-form-item label="内部编号" prop="inno">
          <el-input v-model="temp.inno" placeholder="请填写内部编号" v-if="!temp.id" />
          <span v-else>{{ temp.inno }}</span>
        </el-form-item>
        <el-form-item label="检定时间" prop="day">
          <el-date-picker class="cal" v-model="temp.day" type="date" clearable placeholder="请选检定时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="年限" prop="life">
          <el-select class="filter-item" v-model="temp.life" clearable placeholder="请选年限">
            <el-option v-for="kv in option.life" :key="kv.k" :label="kv.v" :value="kv.k"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检定人" prop="user">
          <el-input v-model="temp.user" placeholder="请填写检定人"/>
        </el-form-item>
        <el-form-item label="级别" prop="level">
          <el-input v-model="temp.level" placeholder="请填写级别"/>
        </el-form-item>
        <el-form-item label="分配组" prop="team">
          <el-input v-model="temp.team" placeholder="请填写分配组"/>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select class="filter-item" v-model="temp.status" clearable placeholder="请选择状态">
            <el-option v-for="kv in option.status" :key="kv.k" :label="kv.v" :value="kv.k"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报废原因" prop="scrap_why" v-if="temp.status == 4">
          <el-input v-model="temp.scrap_why" placeholder="请填写报废原因"/>
        </el-form-item>
        <el-form-item label="报废人" prop="scrap_who" v-if="temp.status == 4">
          <el-input v-model="temp.scrap_who" placeholder="请填写报废人"/>
        </el-form-item>
      </el-form>
       <div slot="footer" class="dialog-footer">
         <el-button @click="dia.edit = false">取消</el-button>
         <el-button type="primary" @click="saveData">确定</el-button>
       </div>
     </el-dialog>
     <!-- edit -->

  </div>
</template>

<script>
import waves from '@/directive/waves'

const option = {
  status: [{k: 1, v: '入库'}, {k: 2, v: '送检'}, {k: 3, v: '复检'}, {k: 4, v: '报废'}],
  life: [{k: 1, v: '一年'}, {k: 2, v: '两年'}, {k: 3, v: '三年'}],
  dash: [{k: 1, v: '今日入库'}, {k: 2, v: '两月待检'}, {k: 3, v: '今日复检'}, {k: 4, v: '报废总计'}],
}

export default {
  name: 'Stats',
  directives: {
    waves
  },
  filters: {
    statusFilter(key) {
      if (key === 0) {
        return '闲置'
      }
      let d = option.status.find(row => row.k == key)
      return d? d.v: '-'
    },
    lifeFilter(key) {
      let d = option.life.find(row => row.k == key)
      return d? d.v: '-'
    }
  },
  data() {
    return {
      tableKey: 0,
      list: [],
      total: 0,
      loading: false,
      search: {
        page: 1,
        size: 12,
        name: '',
        status: '',
        dash: null,
      },
      option: option,
      dia: {
        edit: false
      },
      temp: {},
      rules: {
        inno: [{ required: true, message: '请填写内部编号', trigger: 'blur' }],
        day: [{ required: true, message: '请选择检定时间', trigger: 'blur' }],
        life: [{ required: true, message: '请选择年限', trigger: 'blur' }],
        user: [{ required: true, message: '请填写检定人', trigger: 'blur' }],
        level: [{ required: true, message: '请填写级别', trigger: 'blur' }],
        team: [{ required: true, message: '请填写分配组', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'blur' }]
      }
    }
  },
  created() {
    const chan = this.$store.getters.chan
    if (chan.dash) {
      this.search.dash = chan.dash
      this.search.name = ''
      this.search.status = ''
      this.$store.commit('work/setChan', {'dash': ''})
    }

    this.getList()
  },
  methods: {
    getList() {
      const _t = this
      _t.loading = true
      if (_t.search.status != '') {
        _t.search.dash = ''
      }
      _t.$http.post('/api/ware/', _t.search).then(resp => {
        _t.list = resp.data.list
        _t.total = resp.data.total
        setTimeout(() => {
          _t.loading = false
        }, 200)
      }).catch(() => {
        setTimeout(() => {
          _t.loading = false
        }, 500)
      })
    },
    handleFilter() {
      this.search.page = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.search.page = val
      this.getList()
    },
    handleEdit(row) {
      this.temp = Object.assign({}, row)
      this.dia.edit = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    saveData() {
      const _t = this
      _t.$refs['dataForm'].validate((valid) => {
        if (valid) {
          _t.$http.post('/api/ware/save', _t.temp).then(function(resp) {
            if (resp.code === 0) {
              _t.$message.success(resp.msg)
              _t.dia.edit = false
              _t.getList()
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.tbl {
  .w1 {
    color: #67C23A;
  }
  .w2 {
    color: #E6A23C;
  }
  .w3 {
    color: #409EFF;
  }
  .w4 {
    color: #909399;
  }
}
</style>
